window.SuperDawn = {};

// Add to Cart Form Function
window.addToCartForm = function (e, t = "") {
  return {
    formData: { id: e, quantity: 1, selling_plan: null, properties: {} },
    updateProperties(e) {
      this.formData.properties = e;
    },
    updateProperty(e, t) {
      this.formData.properties[e] = t;
    },
    async submitData() {
      if (typeof obApi === "function") {
        obApi("track", "Add To Cart");
      }
      const e = t.querySelector(".default-element"),
        n = t.querySelector(".box");
      e && n && (e.classList.add("hidden"), (n.style.display = "flex"));
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.formData),
        });
        if (!response.ok) {
          throw new Error("Failed to add item to cart");
        }
        Alpine.store("cartDrawer").openedByATC = true;
        await updateCart();
        e && n && (e.classList.remove("hidden"), (n.style.display = "none"));
      } catch (e) {
        console.error(e);
      }
    },
  };
};

// Update Cart Function
window.updateCart = async function (e = !0) {
  const cartDrawer = document.querySelector("#cart-drawer-wrapper");
  const cartCount = document.querySelector(".js-cart-count");
  const sectionId = cartDrawer.dataset.sectionId;
  let drawerLoading = document.querySelector(".drawer-loading");

  drawerLoading && drawerLoading.classList.remove("hidden");

  await fetch(window.Shopify.routes.root + `?sections=${sectionId}`, {
    credentials: "same-origin",
    headers: {
      "Cache-Control": "no-cache",
    },
  })
    .then((response) => response.json())
    .then(async (data) => {
      const updatedHTML = data[sectionId];
      const tempContainer = document.createElement("div");
      tempContainer.innerHTML = updatedHTML;
      const updatedCartCountHTML = tempContainer.querySelector(".js-cart-count");
      const updatedCartDrawerHTML = tempContainer.querySelector("#cart-drawer-wrapper");

      await fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          Alpine.store("cartDrawer").checkGifts(
            updatedCartDrawerHTML.dataset.cartSubtotal,
            cart.items
          );
        })
        .catch((error) => console.error("Error", error));

      cartDrawer.innerHTML = updatedCartDrawerHTML.innerHTML;
      cartCount.innerHTML = updatedCartCountHTML.innerHTML;

      Alpine.store("cartDrawer").setTotal(updatedCartDrawerHTML.dataset.cartSubtotal);

      Alpine.store("cartDrawer").setOpen(!0);
    })
    .catch((error) => {
      console.error("Error getting cart:", error);
    });

  drawerLoading && drawerLoading.classList.add("hidden");
};

// Update Cart Item Function
window.updateCartItem = function (e, t = 0, n = "") {

  t = parseInt(t) || 0;
  
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ line: e, quantity: t }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Cart update failed: ' + response.status);
      }
      return response.json();
    })
    .then(() => {
      if (
        (updateCart(),
        !0 === Alpine.store("cartDrawer").enable_remove_from_cart_event &&
          0 === t)
      ) {
        const e = {
          currency: n.currency,
          value: n.price,
          page_category: n.template,
          removed_by: n.removed_by,
          items: [
            {
              item_id: n.item_id,
              item_name: n.item_name,
              item_brand: n.item_brand,
              item_category: n.item_category,
              item_variant: n.item_variant,
              price: n.price,
            },
          ],
        };
        gtag("event", "remove_from_cart", e);
      }
    })
    .catch((e) => {
      console.error("Error updating cart item:", e);
    });
};

// Update Cart Item on Page Function
window.updateCartItemPage = async function (e, t = 0, n = "") {
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ line: e, quantity: t }),
  })
    .then(() => {
      if (
        (updateCart(!1),
        !0 === Alpine.store("cartDrawer").enable_remove_from_cart_event &&
          0 === t)
      ) {
        const e = {
          currency: n.currency,
          value: n.price,
          page_category: n.template,
          removed_by: n.removed_by,
          items: [
            {
              item_id: n.item_id,
              item_name: n.item_name,
              item_brand: n.item_brand,
              item_category: n.item_category,
              item_variant: n.item_variant,
              price: n.price,
            },
          ],
        };
        gtag("event", "remove_from_cart", e);
      }
    })
    .catch((e) => {
      console.error(e);
    });
};

// Empty Cart Function
window.emptyCart = function () {
  fetch("/cart/clear.js")
    .then((e) => {
      updateCart(!1);
    })
    .catch((e) => {
      console.error(e);
    });
};

// Remove Specific Items Function
window.removeItems = (e) => {
  let t = { updates: {} };

  e.forEach((e) => {
    t.updates[e] = 0;
  });

  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(t),
  })
    .then(() => {
      window.location.reload(!0);
    })
    .catch((e) => {
      console.error(e);
    });
};